<div class="cms-overlay-backdrop"
     [class.cms-overlay-backdrop--animated]="animated"
     [style.z-index]="zIndex"
     (click)="onClick($event)"></div>
